// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powerbi-security-container {
  padding: 20px;
}

.powerbi-security-container .card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.powerbi-security-container .card-body {
  padding: 1.5rem;
}

.powerbi-security-container .table thead th {
  background-color: var(--color-bg-hover);
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  padding: 12px;
}

.powerbi-security-container .table tbody td {
  vertical-align: middle;
  padding: 12px;
}

.powerbi-security-container .table tbody tr:hover {
  background-color: var(--color-bg-hover);
}

.powerbi-security-container code {
  background-color: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #495057;
}

.powerbi-security-form-container {
  padding: 20px;
}

.powerbi-security-form-container .card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.powerbi-security-form-container .card-header {
  background-color: var(--color-bg-hover);
  border-bottom: 2px solid #dee2e6;
  padding: 1rem 1.5rem;
}

.powerbi-security-form-container .form-check-simple {
  display: inline-flex;
  align-items: center;
}

.powerbi-security-form-container .form-check-input {
  cursor: pointer;
}

.powerbi-security-form-container .form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.powerbi-security-form-container .form-check-label {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
  margin-bottom: 0;
}

.btn-outline-primary:hover {
  color: var(--color-white);
  background-color: var(--color-link-blue);
  border-color: var(--color-link-blue);
}

.btn-outline-danger:hover {
  color: var(--color-white);
  background-color: #dc3545;
  border-color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-security/components/PowerBISecurity.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".powerbi-security-container {\n  padding: 20px;\n}\n\n.powerbi-security-container .card {\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.powerbi-security-container .card-body {\n  padding: 1.5rem;\n}\n\n.powerbi-security-container .table thead th {\n  background-color: var(--color-bg-hover);\n  font-weight: 600;\n  border-bottom: 2px solid #dee2e6;\n  padding: 12px;\n}\n\n.powerbi-security-container .table tbody td {\n  vertical-align: middle;\n  padding: 12px;\n}\n\n.powerbi-security-container .table tbody tr:hover {\n  background-color: var(--color-bg-hover);\n}\n\n.powerbi-security-container code {\n  background-color: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  color: #495057;\n}\n\n.powerbi-security-form-container {\n  padding: 20px;\n}\n\n.powerbi-security-form-container .card {\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.powerbi-security-form-container .card-header {\n  background-color: var(--color-bg-hover);\n  border-bottom: 2px solid #dee2e6;\n  padding: 1rem 1.5rem;\n}\n\n.powerbi-security-form-container .form-check-simple {\n  display: inline-flex;\n  align-items: center;\n}\n\n.powerbi-security-form-container .form-check-input {\n  cursor: pointer;\n}\n\n.powerbi-security-form-container .form-check-input:checked {\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.powerbi-security-form-container .form-check-label {\n  cursor: pointer;\n  user-select: none;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.btn-outline-primary:hover {\n  color: var(--color-white);\n  background-color: var(--color-link-blue);\n  border-color: var(--color-link-blue);\n}\n\n.btn-outline-danger:hover {\n  color: var(--color-white);\n  background-color: #dc3545;\n  border-color: #dc3545;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
